"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var requiredKeys = ['authType', 'rootUrl', 'tracker', 'blockingRequests', 'getPurchaseMotions', 'defaultHubRoute']; //const exampleInterface = {
//  // Env-specific data
//  getLang: () => { ... },
//  getPurchaseMotions: () => { ... }
//  tracker: _PublicUsageTracker(),
//
//  // Env-specific business rules
//  allowTrials: false,
//  allowInlineChat: true,
//  allowMultiCurrency: true,
//  allowMon256Experiment: false,
//}
// Validates that a config has all the required keys

var _default = function _default(config) {
  requiredKeys.forEach(function (key) {
    if (config[key] === undefined) {
      throw new Error("config is missing " + key);
    }
  });
  return config;
};

exports.default = _default;
module.exports = exports.default;